// ------- 1 -> Popular-Search Data ------- //
export const popularsearchcontent = [
  {
    name: "Banarasi Saree ",
    href: "",
  },
  {
    name: "Embroidery Saree",
    href: "",
  },
  {
    name: "Patola Saree",
    href: "",
  },
];
